<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="part"><a id="page11"></a><a id="page12"></a><a class="hlink" href="#/OEBPS/toc.htm#part1" id="part1"><em>part one</em></a></h1>
<h1 class="subpart"><a class="hlink" href="#/OEBPS/toc.htm#part1">Darkness Falls</a></h1>
<p class="center"><img alt="" src="OEBPS/images/13-1.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?8f54d2b4